export default {
  'pages.reviews.title': '评论管理',
  'pages.reviews.platformReviews': '平台评论',
  'pages.reviews.userReviews': '用户评论',
  'pages.reviews.platformToUser': '平台 → 用户商品',
  'pages.reviews.userToProduct': '用户 → 商品',
  'pages.reviews.platformReviewsDescription': '平台对用户商品的评论',
  'pages.reviews.userReviewsDescription': '用户对商品的评论',
  
  // Common
  'pages.reviews.user': '用户',
  'pages.reviews.sender': '发送者',
  'pages.reviews.seller': '卖家',
  'pages.reviews.rating': '评分',
  'pages.reviews.rating.positive': '正面',
  'pages.reviews.rating.neutral': '中性',
  'pages.reviews.rating.negative': '负面',
  'pages.reviews.content': '内容',
  'pages.reviews.images': '图片',
  'pages.reviews.imagesCount': '张',
  'pages.reviews.processingMemo': '处理备注',
  'pages.reviews.createdAt': '创建时间',
  'pages.reviews.updatedAt': '更新时间',
  'pages.reviews.status': '状态',
  'pages.reviews.actions': '操作',
  
  // Platform Reviews
  'pages.reviews.platform.title': '标题',
  'pages.reviews.platform.status.active': '活跃',
  'pages.reviews.platform.status.hidden': '隐藏',
  'pages.reviews.platform.write': '写评论',
  'pages.reviews.platform.writeReview': '写商品评论',
  'pages.reviews.platform.send': '发送',
  'pages.reviews.platform.reviewSent': '评论发送成功',
  'pages.reviews.platform.reviewError': '评论发送失败',
  'pages.reviews.platform.ratingRequired': '请选择评分',
  
  // User Reviews
  'pages.reviews.user.productInfo': '商品信息',
  'pages.reviews.user.productNumber': '商品编号',
  'pages.reviews.user.productName': '商品名称',
  'pages.reviews.user.sellerName': '卖家',
  'pages.reviews.user.reviewText': '评论内容',
  'pages.reviews.user.reviewImages': '评论图片',
  'pages.reviews.user.platformComment': '平台评论',
  'pages.reviews.user.status.pending': '待处理',
  'pages.reviews.user.status.approved': '已批准',
  'pages.reviews.user.status.rejected': '已拒绝',
  
  // Actions
  'pages.reviews.edit': '编辑',
  'pages.reviews.delete': '删除',
  'pages.reviews.approve': '批准',
  'pages.reviews.reject': '拒绝',
  'pages.reviews.comment': '评论',
  'pages.reviews.commentAndNotes': '评论/备注',
  'pages.reviews.action.view': '查看',
  'pages.reviews.action.respond': '回复',
  
  // Modal
  'pages.reviews.modal.commentTitle': '平台评论',
  'pages.reviews.modal.editTitle': '编辑平台评论',
  'pages.reviews.modal.approveTitle': '批准评论',
  'pages.reviews.modal.rejectTitle': '拒绝评论',
  'pages.reviews.modal.platformComment': '平台评论',
  'pages.reviews.modal.platformCommentPlaceholder': '输入给用户的评论...',
  'pages.reviews.modal.processingMemo': '处理备注（内部）',
  'pages.reviews.modal.processingMemoPlaceholder': '输入内部处理备注...',
  'pages.reviews.modal.handlingNotes': '处理备注（内部）',
  'pages.reviews.modal.handlingNotesPlaceholder': '输入内部处理备注...',
  'pages.reviews.modal.save': '保存',
  'pages.reviews.modal.cancel': '取消',
  'pages.reviews.contentRequired': '请输入评论内容',
  'pages.reviews.contentPlaceholder': '输入评论内容...',
  'pages.reviews.handlingNotesRequired': '请输入处理备注',
  'pages.reviews.handlingNotesPlaceholder': '输入处理备注...',
  'pages.reviews.imageUploadNote': '最多上传5张图片（每张3MB）',
  'pages.reviews.addImage': '添加图片',
  
  // Messages
  'pages.reviews.deleteConfirm': '确定要删除吗？',
  'pages.reviews.rejectConfirm': '确定要拒绝吗？',
  'pages.reviews.deleted': '删除成功',
  'pages.reviews.approved': '批准成功',
  'pages.reviews.rejected': '拒绝成功',
  'pages.reviews.commentSaved': '评论保存成功',
  'pages.reviews.commentRequired': '请输入评论',
  'pages.reviews.fetchError': '获取评论列表失败',
  'pages.reviews.deleteError': '删除失败',
  'pages.reviews.updated': '评论更新成功',
  'pages.reviews.updateError': '更新失败',
  'pages.reviews.commentError': '评论保存失败',
  'pages.reviews.approveError': '批准失败',
  'pages.reviews.rejectError': '拒绝失败',
  'pages.reviews.permissionDenied': '权限不足',
  'pages.reviews.noPermissionToEdit': '您没有权限编辑此评论',
  
  // Search
  'pages.reviews.search.userName': '用户名',
  'pages.reviews.search.productName': '商品名称',
  'pages.reviews.search.sellerName': '卖家名称',
  'pages.reviews.search.title': '标题',
  
  // Suggestion page (Platform Reviews)
  'pages.suggestion.tab.item': '商品质量 (Item as Described)',
  'pages.suggestion.tab.customerService': '客户服务 (Customer Service)',
  'pages.suggestion.tab.delivery': '配送服务质量 (Delivery Service Quality)',
  'pages.suggestion.item.title': '商品质量评论',
  'pages.suggestion.cs.title': '客户服务评论',
  'pages.suggestion.delivery.title': '配送服务评论',
  'pages.suggestion.reviewType': '评论类型',
  'pages.suggestion.reviewType.item': '商品质量',
  'pages.suggestion.reviewType.customerService': '客户服务',
  'pages.suggestion.reviewType.delivery': '配送服务',
  'pages.suggestion.detailTitle': '平台评论详情',
  'pages.suggestion.responseTitle': '平台评论回复',
};